import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  type ChangeInstallmentPlanPayload,
  type ChangeInstallmentPlanSummary,
} from "@fitness-app/data-models/entities/InstallmentPlanChange";
import { getError } from "@fitness-app/utils";

import { type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";

export { type ChangeInstallmentPlanPayload, type ChangeInstallmentPlanSummary };

export const changeInstallmentPlan = createAsyncThunk<
  ChangeInstallmentPlanSummary,
  ChangeInstallmentPlanPayload,
  AsyncThunkCreator<string>
>(
  `${PRODUCT_CLIENT_REDUCER}/changeInstallmentPlan`,
  async (payload, { rejectWithValue, extra: { productApi, analytics } }) => {
    try {
      const res = await productApi.post<ChangeInstallmentPlanSummary>("/change-installment-plan", payload);

      if (!payload.dryRun) {
        analytics.track("change_installment_plan", {
          productClientId: payload.productClientId,
          newInstallments: payload.newInstallments ?? null,
          newInstallmentAmount: payload.newInstallmentAmount ?? null,
          newPriceId: payload.newPriceId ?? null,
        });
      }

      return res.data;
    } catch (e) {
      // The backend refuses with a human-readable Polish reason — surface it.
      return rejectWithValue(getError(e).message);
    }
  },
);
